import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@ngbracket/ngx-layout/flex';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [MatToolbarModule, FlexModule, MatButtonModule, MatIconModule, ExtendedModule, RouterLink]
})
export class FooterComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
